import React from 'react'

import styled from 'styled-components'

import { fonts, orangeGradientText } from '../../styles'

interface Props {
  isSmallFont?: boolean
}

export const StyledText = styled.h3<Props>`
  ${(props) => (props.isSmallFont ? fonts.AN_40_600_55 : fonts.AN_60_600_60)}
  ${orangeGradientText}
  margin: 0 0 10px;
  padding: 0;
  width: 100%;
  min-width: 275px;
`

const DetailHeader = ({
  children,
  isSmallFont,
}: {
  children: string
  isSmallFont?: boolean
}): React.ReactElement => {
  return <StyledText isSmallFont={isSmallFont}>{children}</StyledText>
}

export { DetailHeader }
